exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nh1[data-v-f4ae9012]{text-align:center\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/vippay-system-manager-merchant/src/components/welcomes/index.vue"],"names":[],"mappings":";AACA,oBAAoB,iBAAiB;CACpC","file":"index.vue","sourcesContent":["\nh1[data-v-f4ae9012]{text-align:center\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f4ae9012","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/welcomes/index.vue
// module id = fgs0
// module chunks = 1